import React from "react";
import { useMediaQuery } from "@mui/material";
import FullStack from "../../Assests/Images/full_stack.svg";
import Programming from "../../Assests/Images/programming.svg";
import Collaborate from "../../Assests/Images/collaborate.svg";

function Section3() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <section
      style={{
        marginTop: isSmallScreen ? "-7rem" : "-10rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          height: "100%",
          width: "90%",
          backgroundColor: "white",
          borderRadius: "20px",
          boxShadow: "0 5px 5px 0 rgba(233, 240, 243, 0.5), 0 0 0 1px #E6ECF8",
          color: "#141c3a",
          display: "block",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {[
            {
              image: FullStack,
              title: "Full Stack Developer",
              description: `I like to code things from scratch, and enjoy bringing ideas to
              life in the browser. I am passionate about working on both client
              and server software.`,
              techs: "Django, Node.js, React, MongoDB, PostgreSQL",
              devTools: ["VS Code", "Docker", "GitHub", "Jenkins", "Figma", "Bootstrap"],
            },
            {
              image: Programming,
              title: "Competitive Programmer",
              description: `I thrive on problem-solving and algorithms. I enjoy the thrill of
              competition and the satisfaction of seeing my code run
              successfully against challenging problems.`,
              techs: "C, C++, Python",
              devTools: ["Codeforces", "CodeChef", "Leetcode"],
            },
            {
              image: Collaborate,
              title: "Collaborator",
              description: `I believe in the power of teamwork and diverse perspectives. I
              enjoy working with others to achieve common goals and learn from
              shared experiences.`,
              techs: "Agile Development, Code Reviews, Hackathons",
              devTools: [
                "2+ years experience",
                "5+ team projects",
                "5+ pair programming sessions",
                "10+ code reviews",
                "3+ hackathons",
              ],
            },
          ].map((item, index) => (
            <div
              key={index}
              style={{
                // width: "100%",
                padding: isSmallScreen ? "25px 20px" : "75px 45px",
                display: "flex",
                alignItems: "center",
                borderBottom: isSmallScreen ? (index !== 2 ? "1px solid #E6ECF8" : "0px") : "0px",
                borderRight: isSmallScreen ? "0px" : (index !== 2 ? "1px solid #E6ECF8" : "0px"),
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  backgroundColor: "#5BE9B9",
                  width: "72px",
                  height: "67px",
                  borderRadius: "72px",
                  display: "flex",
                  paddingTop: "5px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img alt={item.title} width="40px" src={item.image} />
              </div>
              <h1
                style={{
                  fontFamily: "Font1",
                  fontWeight: "800",
                  fontSize: isSmallScreen ? "20px" : "24px",
                  margin: "24px 0px",
                  letterSpacing: "1px",
                  textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
                  color: "#141c3a",
                }}
              >
                {item.title}
              </h1>
              <p
                style={{
                  fontSize: isSmallScreen ? "16px" : "18px",
                  marginBottom: "36px",
                  fontFamily: "Font2",
                }}
              >
                {item.description}
              </p>
              <p
                style={{
                  fontSize: isSmallScreen ? "16px" : "18px",
                  margin: "50px 0px 8px",
                  fontFamily: "Font2",
                  color: "#6E07F3",
                }}
              >
                {index === 0
                  ? "Technologies I work with:"
                  : index === 1
                  ? "Languages I speak:"
                  : "Synergies I create:"}
              </p>
              <p
                style={{
                  fontSize: isSmallScreen ? "16px" : "18px",
                  marginBottom: "36px",
                  marginTop: "0",
                  fontFamily: "Font2",
                }}
              >
                {item.techs}
              </p>
              <p
                style={{
                  fontSize: isSmallScreen ? "16px" : "18px",
                  margin: "50px 0px 8px",
                  fontFamily: "Font2",
                  color: "#6E07F3",
                }}
              >
                {index === 0
                  ? "Dev Tools:"
                  : index === 1
                  ? "Coding Platforms:"
                  : "Collaboration Stats:"}
              </p>
              <ul>
                {item.devTools.map((tool, toolIndex) => (
                  <li key={toolIndex}>{tool}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Section3;
